/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetApiOfficesIdQueryResponse,
  GetApiOfficesIdPathParams,
} from '../models/GetApiOfficesId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiOfficesIdQueryResponseSchema } from '../zod/getApiOfficesIdSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiOfficesIdQueryKey = (id: GetApiOfficesIdPathParams['id']) =>
  [{ url: '/api/offices/:id', params: { id: id } }] as const;

export type GetApiOfficesIdQueryKey = ReturnType<
  typeof getApiOfficesIdQueryKey
>;

/**
 * {@link /api/offices/:id}
 */
export async function getApiOfficesId(
  id: GetApiOfficesIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiOfficesIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: `/api/offices/${id}`, ...requestConfig });
  return getApiOfficesIdQueryResponseSchema.parse(res.data);
}

export function getApiOfficesIdQueryOptions(
  id: GetApiOfficesIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiOfficesIdQueryKey(id);
  return queryOptions<
    GetApiOfficesIdQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiOfficesIdQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiOfficesId(id, config);
    },
  });
}

/**
 * {@link /api/offices/:id}
 */
export function useGetApiOfficesId<
  TData = GetApiOfficesIdQueryResponse,
  TQueryData = GetApiOfficesIdQueryResponse,
  TQueryKey extends QueryKey = GetApiOfficesIdQueryKey,
>(
  id: GetApiOfficesIdPathParams['id'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiOfficesIdQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiOfficesIdQueryKey(id);

  const query = useQuery(
    {
      ...getApiOfficesIdQueryOptions(id, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
